// ローディング画面
const Loading = {
  namespaced: true,

  state: {
    loading: false,
  },
  getters: {
    getLoading: state => {
      return state.loading
    },
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('setLoading', loading)
    },
  },
}

export default Loading
